module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_yanatrip.f492ad5f593454f0fb6d081373dc61a3.png";